import { render, staticRenderFns } from "./DetalleAnticipo.vue?vue&type=template&id=73413c45"
import script from "./DetalleAnticipo.vue?vue&type=script&lang=js"
export * from "./DetalleAnticipo.vue?vue&type=script&lang=js"
import style0 from "./DetalleAnticipo.vue?vue&type=style&index=0&id=73413c45&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports